import React, { Component } from 'react';
import { Checkbox, Button, Form, message } from 'antd';
import './purchase.less';
import ServiceAgreement from 'CMPT/common/serviceAgreement'
import Upload from 'CMPT/common/Upload';
import { API } from '@/http/api';
import http from '@/http';

class BuyForm extends Component {

    state = {
        visible: false,
        selected: '',
        amountPayable: 0,
        read: false,
        payVoucher: '',
        setMealData: [
            {
                check: false,
                itemCode: 1,
                itemName: "A套餐",
                payPrice: 2000,
                perPrice: 1,
                serviceNumber: 2000,
            },
            {
                check: false,
                itemCode: 2,
                itemName: "B套餐",
                payPrice: 10000,
                perPrice: 0.9,
                serviceNumber: 11111,
            },
            {
                check: false,
                itemCode: 3,
                itemName: "C套餐",
                payPrice: 20000,
                perPrice: 0.8,
                serviceNumber: 25000,
            },
            {
                check: true,
                itemCode: 4,
                itemName: "D套餐",
                payPrice: 50000,
                perPrice: 0.7,
                serviceNumber: 71000,
            }
        ]
    }

    componentDidMount() {
    }
    onCancel = () => {
        this.setState({
            visible: false
        })
    }
    onOk = () => {
        this.setState({
            visible: false,
            read: true,
        })
    }

    handleSubmit = () => {
        if (this.state.amountPayable == 0) {
            message.warning("请选择套餐！");
            return;
        }
        this.props.form.validateFields((err, values) => {
            console.log("err", !err);
            if (!err) {
                const params = {
                    mealType: this.state.selected,
                    payVoucher: this.state.payVoucher
                }
                const config = {
                    api: API.userRecharge,
                    data: params
                };
                http(config).then(res => {
                    if (res.code == 200) {
                        message.success(res.msg);
                        setTimeout(() => {
                            this.props.history.push('/app/crm/servicePurchase')
                        }, 2000)
                    }
                })
            }
        })
    }

    // 文件上传前拦截
    handleBeforeUpload = file => {
        const size = file.size;
        if (size / 1024 / 1024 > 2) {
            message.error("请上传2M以内的图片");
            return false;
        }
    };
    // 付款凭证上传回调
    payMoneyChange = value => {
        if (value.file.status === "done") {
            let item = value.file.response.file;
            this.setState({ payVoucher: item.absolutePath });
        }
    };
    changePackages = (code, payPrice) => {
        this.setState({
            selected: code,
            amountPayable: payPrice,
        })
    }
    render() {
        const { setMealData, amountPayable, read, selected, visible, payVoucher } = this.state;
        const { getFieldDecorator } = this.props.form;
        return (
            <div className='purchase'>
                <div className='top'>
                    <p className='top_title'>选择套餐</p>
                    <div className='packages_list'>
                        {setMealData &&
                            setMealData.map((item, index) => {
                                return (
                                    <div
                                        key={item.itemCode}
                                        className={
                                            (selected === item.itemCode ? "packages_item packages_item_selected" : "packages_item")
                                        }
                                        onClick={() => {
                                            this.changePackages(item.itemCode, item.payPrice)
                                        }}
                                    >
                                        <div
                                            className={
                                                (item.check ? "recommend recommend_show" : "recommend")
                                            }
                                        >
                                            推荐购买
                                        </div>
                                        <div className='packages_item_name'>{item.itemName}</div>
                                        <div className='packages_item_price'>
                                            <span className='packages_item_price_serviceNumber'>
                                                {item.serviceNumber}次
                                            </span>
                                            <span>{item.perPrice}元/次</span>
                                        </div>
                                        <div className='packages_item_payPrice'>
                                            <span className='packages_item_symbol'>￥</span>
                                            <span>{item.payPrice}</span>
                                        </div>
                                    </div>
                                )
                            })}
                    </div>
                    <p className='explain'>
                        说明：关于轨迹查询产品服务、付款方面如有问题可联系客服：4000711718
                    </p>
                </div>
                <div className='bottom'>
                    <div className='account_info'>
                        <div className='list_item'>
                            <span className='label'>应付金额</span>
                            <span className='amount_payable'>￥{amountPayable}</span>
                        </div>
                        <div className='list_item'>
                            <span className='label'>商家账户</span>
                            <span className='contents'>数通十方（深圳）数字科技有限公司</span>
                        </div>
                        <div className='list_item'>
                            <span className='label'>开户银行</span>
                            <span className='contents'>中国建设银行股份有限公司深圳创业支行  </span>
                        </div>
                        <div className='list_item'>
                            <span className='label'>银行卡号</span>
                            <span className='contents'>44250100008100002815</span>
                        </div>
                    </div>
                    <div className='form_box'>
                        <Form onSubmit={this.handleSubmit}>
                            <div className="intention-add-body">
                                <div>
                                    <Form.Item label="付款凭证" >
                                        {getFieldDecorator(
                                            "payVoucher", {
                                            rules: [{
                                                required: true, message: '请上传付款凭证',
                                            }],
                                        }
                                        )(
                                            <div>
                                                <span className='font'>请将付款流水凭证图片上传并提交，平台确认成功即购买成功</span>
                                                <div className="upload-img-list">
                                                    {payVoucher ?
                                                        <img src={payVoucher} /> : ''
                                                    }
                                                    <div className='upload_box'>
                                                        <Upload action={API.uploadAdd.url}
                                                            beforeUpload={this.handleBeforeUpload}
                                                            accept=".png,.jpg"
                                                            onChange={this.payMoneyChange}
                                                            showUploadList={false}
                                                            listType="picture-card">
                                                        </Upload>
                                                    </div>
                                                </div>
                                            </div>

                                        )
                                        }
                                    </Form.Item>
                                </div>
                            </div>
                        </Form>
                    </div>
                    <div>
                        <Checkbox
                            checked={read}
                            onChange={(e) => {
                                this.setState({
                                    read: e.target.checked
                                })
                            }}
                        >
                            我已阅读并同意
                            <span
                                onClick={(e) => {
                                    e.preventDefault()
                                    this.setState({
                                        visible: true
                                    })
                                }}
                                className='link'
                            >
                                《轨迹查询服务协议》
                            </span>
                        </Checkbox>
                    </div>

                    <Button type="primary" disabled={!read} className='primary' onClick={this.handleSubmit}>
                        确认购买
                    </Button>
                </div>
                <ServiceAgreement visible={visible} onCancel={this.onCancel} onOk={this.onOk} />
            </div >
        );
    }
}

const purchase = Form.create({ name: "BuyForm" })(BuyForm);
export default purchase;